import useTranslation from 'next-translate/useTranslation';
import { FC } from 'react';

import { Translate } from '@core/constant';
import { EActionAttribute, EColor, ERouting, ETypographyVariant } from '@core/type';

import { Box } from '../layout';
import type { LinkTranslatedLegacyProps } from '../link';
import { LinkTranslatedStyledAsLink } from '../link-translated';
import { TextWithLineLimit } from '../typography';
import { CardMedia } from './CardMedia';
import { StyledCardHeader } from './StyledCardHeader';
import { StyledCardMediaWrapper } from './StyledCardMediaWrapper';
import { CardVideoTutorialProps } from './interface-card';

export const CardVideoTutorial: FC<CardVideoTutorialProps> = ({ title, imageProps, slug }) => {
  const linkTranslatedProps: Omit<LinkTranslatedLegacyProps, 'children'> = {
    keyRoute: ERouting.TUTORIAL_VIDEO,
    query: { slug },
  };

  const { t } = useTranslation(Translate.common.ARIA);

  return (
    <Box as={EActionAttribute.ARTICLE} aria-label={t('articleCard')}>
      <StyledCardMediaWrapper headerColor={EColor.PRIMARY}>
        <LinkTranslatedStyledAsLink {...linkTranslatedProps}>
          <CardMedia height={208} image={imageProps} aria-label={'articleMedia'} />
        </LinkTranslatedStyledAsLink>
      </StyledCardMediaWrapper>
      <StyledCardHeader as={EActionAttribute.HEADER} aria-label={'articleHeader'}>
        <TextWithLineLimit lines={5} as={EActionAttribute.H3}>
          <LinkTranslatedStyledAsLink
            {...linkTranslatedProps}
            display={'inline'}
            as={EActionAttribute.LINK}
            variant={ETypographyVariant.H4}
          >
            {title}
          </LinkTranslatedStyledAsLink>
        </TextWithLineLimit>
      </StyledCardHeader>
    </Box>
  );
};
